import { useEffect, useRef } from "react";

const TEST_SITE_KEY = "1x00000000000000000000AA";

function siteKey() {
  const prod = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  // Cloudflare widgets only render on whitelisted domains: prod key on pulse.lypinn.com, test key elsewhere (preview/dev).
  if (typeof window !== "undefined" && window.location.hostname === "pulse.lypinn.com") return prod;
  return TEST_SITE_KEY;
}

export default function TurnstileWidget({ onToken, testid = "turnstile-widget" }) {
  const container = useRef(null);
  const rendered = useRef(false);

  useEffect(() => {
    rendered.current = false;
    let attempts = 0;
    const tryRender = () => {
      if (rendered.current || !container.current) return;
      if (window.turnstile && typeof window.turnstile.render === "function" && siteKey()) {
        try {
          window.turnstile.render(container.current, {
            sitekey: siteKey(),
            theme: "dark",
            callback: onToken,
            "expired-callback": () => onToken(""),
            "error-callback": () => onToken(""),
          });
          rendered.current = true;
          return;
        } catch {
          /* retry below */
        }
      }
      attempts += 1;
      if (attempts < 50) setTimeout(tryRender, 200);
    };
    const timer = setTimeout(tryRender, 100);
    return () => clearTimeout(timer);
  }, [onToken]);

  return <div ref={container} data-testid={testid} className="flex justify-start min-h-[65px]" aria-label="Bot protection" />;
}
